
export const DEFAULT_BOOKING_SETTINGS = {
  START_TIME: "09:00",
  END_TIME: "17:00",
  BUFFER_BEFORE: 15,
  BUFFER_AFTER: 15,
  MIN_NOTICE_TIME: 60,
  ENERGY_PREFERENCE: "focus",
  DURATION: 30,
  MAX_PER_DAY: 3,
  WAKE_TIME: 7,
  BUSINESS_NAME: "ChronoCal",
  WAKE_TIME_STRING: "07:00"
} as const;
